import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SharedModule } from 'src/app/shared/shared.module';
import { LeadCreateComponent } from './lead-create/lead-create.component';
import { LeadDetailsCarInsuranceComponent } from './lead-details/lead-details-tab/lead-details-car-insurance/lead-details-car-insurance.component';
import { LeadDetailsDriverComponent } from './lead-details/lead-details-tab/lead-details-driver/lead-details-driver.component';
import { LeadDetailsHealthComponent } from './lead-details/lead-details-tab/lead-details-health/lead-details-health.component';
import { LeadDetailsHouseComponent } from './lead-details/lead-details-tab/lead-details-house/lead-details-house.component';
import { LeadDetailsInsuredComponent } from './lead-details/lead-details-tab/lead-details-insured/lead-details-insured.component';
import { LeadDetailsMarketingComponent } from './lead-details/lead-details-tab/lead-details-marketing/lead-details-marketing.component';
import { LeadDetailsQuotesComponent } from './lead-details/lead-details-tab/lead-details-quotes/lead-details-quotes.component';
import { LeadDetailsCallsComponent } from './lead-details/lead-details-tab/lead-details-calls/lead-details-calls.component';
import { LeadDetailsVehicleComponent } from './lead-details/lead-details-tab/lead-details-vehicle/lead-details-vehicle.component';
import { LeadDetailsComponent } from './lead-details/lead-details.component';
import { LeadTabsDetailsComponent } from './lead-details/lead-tabs-details/lead-tabs-details.component';
import { LeadEditComponent } from './lead-edit/lead-edit.component';
import { LeadFormCarInsuranceComponent } from './lead-form/lead-form-tab/lead-form-car-insurance/lead-form-car-insurance.component';
import { LeadFormDriverComponent } from './lead-form/lead-form-tab/lead-form-driver/lead-form-driver.component';
import { LeadFormHealthComponent } from './lead-form/lead-form-tab/lead-form-health/lead-form-health.component';
import { LeadFormHouseComponent } from './lead-form/lead-form-tab/lead-form-house/lead-form-house.component';
import { LeadFormMarketingComponent } from './lead-form/lead-form-tab/lead-form-marketing/lead-form-marketing.component';
import { LeadFormVehicleComponent } from './lead-form/lead-form-tab/lead-form-vehicle/lead-form-vehicle.component';
import { LeadTabsFormComponent } from './lead-form/lead-tabs-form/lead-tabs-form.component';
import { LeadLostReasonContentComponent } from './lead-lost-reason-content/lead-lost-reason-content.component';
import { LeadRoutingModule } from './lead-routing.module';
import { LeadDetailsQuotesScraperComponent } from './lead-details/lead-details-tab/lead-details-quotes-scraper/lead-details-quotes-scraper.component';
import { ArrayStringPipe } from './lead-details/lead-details-tab/lead-details-quotes-scraper/array-string.pipe';
import { CounselorChoiceQuoteOcealizComponent } from './lead-details/lead-details-tab/lead-details-quotes-scraper/counselor-choice-quote-ocealiz/counselor-choice-quote-ocealiz.component';
import { ToLocalTimePipe } from '../../../shared/pipe/local-time/to-local-time.pipe';
import { LeadDetailsDuplicatesComponent } from './lead-details/lead-details-tab/lead-details-duplicates/lead-details-duplicates.component';
import { LeadSetAsDuplicatesContentComponent } from './lead-details/lead-details-tab/lead-details-duplicates/lead-set-as-duplicates-content/lead-set-as-duplicates-content.component';
@NgModule({
  declarations: [
    LeadDetailsComponent,
    LeadDetailsCarInsuranceComponent,
    LeadDetailsDriverComponent,
    LeadDetailsHouseComponent,
    LeadDetailsVehicleComponent,
    LeadDetailsHealthComponent,
    LeadDetailsMarketingComponent,
    LeadEditComponent,
    LeadFormCarInsuranceComponent,
    LeadFormHealthComponent,
    LeadFormMarketingComponent,
    LeadFormDriverComponent,
    LeadFormHouseComponent,
    LeadFormVehicleComponent,
    LeadCreateComponent,
    LeadDetailsInsuredComponent,
    LeadTabsDetailsComponent,
    LeadTabsFormComponent,
    LeadLostReasonContentComponent,
    LeadDetailsQuotesComponent,
    LeadDetailsCallsComponent,
    LeadDetailsQuotesScraperComponent,
    ArrayStringPipe,
    CounselorChoiceQuoteOcealizComponent,
    LeadDetailsDuplicatesComponent,
    LeadSetAsDuplicatesContentComponent,
  ],
  imports: [CommonModule, SharedModule, LeadRoutingModule, ToLocalTimePipe],
  exports: [LeadLostReasonContentComponent],
})
export class LeadModule {}
